// extracted by mini-css-extract-plugin
module.exports = {"audioControlsButton":"AudioControlsButton_audioControlsButton__3nzGj","audioButton":"AudioControlsButton_audioButton__3D2nA"};